import type { CandidateProgramConfig } from './types';
import { toProgramConfig } from './types';

import chargesManager from './charges-manager/config.json';
import covid from './covid/config.json';
import covidTesting from './covid-testing/config.json';
import covidVaccine from './covid-vaccine/config.json';
import dsh from './dsh/config.json';
import fist from './fist/config.json';
import influenzaVaccine from './influenza-vaccine/config.json';
import inrep from './inrep/config.json';
import lai from './lai/config.json';
import laiCommunity from './lai-community/config.json';
import lead from './lead/config.json';
import maternal from './maternal/config.json';
import mist from './mist/config.json';
import monkeypoxVaccine from './monkeypox-vaccine/config.json';
import odr from './odr/config.json';
import olive from './olive/config.json';
import oliveVista from './olive-vista/config.json';
import progressReport from './progress-report/config.json';

type CandidateProgramConfigSource = Parameters<typeof toProgramConfig>[0];

const rawProgramConfigs: Record<string, CandidateProgramConfigSource> = {
  'charges-manager': chargesManager,
  covid,
  'covid-testing': covidTesting,
  'covid-vaccine': covidVaccine,
  dsh,
  fist,
  'influenza-vaccine': influenzaVaccine,
  inrep,
  lai,
  'lai-community': laiCommunity,
  lead,
  maternal,
  mist,
  'monkeypox-vaccine': monkeypoxVaccine,
  odr,
  olive,
  'olive-vista': oliveVista,
  'progress-report': progressReport,
};

export const CANDIDATE_PROGRAMS: Record<string, CandidateProgramConfig> = Object.fromEntries(
  Object.entries(rawProgramConfigs).map(([key, value]) => [key, toProgramConfig(value)]),
);
